import React from "react";
import classNames from "classnames";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import * as styles from "./style.module.css";
/**
 * A single choice list, where every option is a clickable card.
 */
export default function RadioCardList(props) {
    const { options, value, onChange, onActivate, maxHeight } = props;
    const [listAnimation] = useAutoAnimate();
    return (React.createElement("ul", { className: styles.list, style: { maxHeight }, ref: listAnimation, role: "radiogroup" }, options.map((option) => {
        const isChosen = option.value === value;
        return (React.createElement("li", { key: option.value },
            React.createElement("button", { type: "button", role: "radio", "aria-checked": isChosen, className: classNames(styles.option, {
                    [styles["option_chosen"]]: isChosen,
                }), onClick: () => onChange(option.value), onDoubleClick: () => onActivate === null || onActivate === void 0 ? void 0 : onActivate(option.value) },
                option.icon,
                React.createElement("span", { className: styles["option_text"] },
                    React.createElement("span", { className: styles["option_title"] }, option.title),
                    option.description && (React.createElement("span", { className: styles["option_description"] }, option.description))),
                option.badge && (React.createElement("span", { className: styles.badge }, option.badge)))));
    })));
}
